<div *ngIf="usuario && usuario.sucesso" class="container-fluid PADRAO px-5">
  <!-- HEADER INI -->
  <app-breadcrumb-title [titulo]="'Central de Bloqueios'"></app-breadcrumb-title>

  <!-- HEADER END -->

  <div *ngIf="bloqueios != undefined && bloqueios.length > 0" class="mt-4">
    <div class="row">
      <div class="col-md-3 mb-3" *ngFor="let b of bloqueios">
        <div class="bloqueio-card h-100 card text-center p-3">
          <h5 class="fw-bold">{{ b.dscBloqueio }}</h5>
          <div class="row">
            <div class="col-4" *ngIf="!b.ocultaFrota">
              <p class="mb-1 w-100 sub-titulo text-start">Frotas</p>
              <ng-container *ngIf="b.qtdFrotas > 0; else noLink">
                <button (click)="openDetalheBloqueioLista(b, 2)" class="btn ms-2 link">
                  <h6 class="w-100 fw-bold pull-left text-start">
                    {{ b.qtdFrotas }}
                  </h6>
                </button>
              </ng-container>
              <ng-template #noLink>
                <h6 class="w-100 fw-bold pull-left text-start">
                  {{ b.qtdFrotas }}
                </h6>
              </ng-template>
            </div>
            <div class="col-4" *ngIf="!b.ocultaSubfrota">
              <p class="mb-1 w-100 sub-titulo text-start">Subfrotas</p>
              <ng-container *ngIf="b.qtdSubFrotas > 0; else noLink">
                <button (click)="openDetalheBloqueioLista(b, 6)" class="btn ms-2 link">
                  <h6 class="w-100 fw-bold pull-left text-start">
                    {{ b.qtdSubFrotas }}
                  </h6>
                </button>
              </ng-container>
              <ng-template #noLink>
                <h6 class="w-100 fw-bold pull-left text-start">
                  {{ b.qtdSubFrotas }}
                </h6>
              </ng-template>
            </div>
            <div class="col-4" *ngIf="!b.ocultaVeiculo">
              <p class="mb-1 w-100 sub-titulo text-start">Veículos</p>
              <ng-container *ngIf="b.qtdVeiculos > 0; else noLink">
                <button (click)="openDetalheBloqueioLista(b, 7)" class="btn ms-2 link">
                  <h6 class="w-100 fw-bold pull-left text-start">
                    {{ b.qtdVeiculos }}
                  </h6>
                </button>
              </ng-container>
              <ng-template #noLink>
                <button class="btn ms-2 link" style="cursor: not-allowed;">
                  <h6 class="w-100 fw-bold pull-left text-start">
                    {{ b.qtdVeiculos }}
                  </h6>
                </button>
              </ng-template>
            </div>
          </div>
          <div class="row" *ngIf="b.qtdTransacoesAfetadas > 0">
            <p class="mb-1 w-100 text-start">Transações negadas</p>
            <h6 class="text-danger fw-bold pull-left text-start">
              {{ b.qtdTransacoesAfetadas }}
            </h6>
          </div>
          <div class="row" *ngIf="false">
            <button class="btn btn-link text-danger fw-bold">
              📄 Gerar relatório
            </button>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="false" class="text-center mt-4">
      <button class="btn btn-primary w-50">Todos os bloqueios ⌄</button>
    </div>
  </div>


  <div *ngIf="loading > 0" class="row mb-4">
    <div class="col-md-12">
      <ngx-skeleton-loader count="1" appearance="line" [theme]="{
          'background-color': '#ebebeb',
          height: '480px',
          'border-radius': '16px',
          'margin-bottom': '16px'
        }">
      </ngx-skeleton-loader>
    </div>
  </div>

  <!-- DASHBOARD END -->
  <div *ngIf="loadingTransacoes > 0" class="row mb-4">
    <div class="col-md-12">
      <ngx-skeleton-loader count="1" appearance="line" [theme]="{
          'background-color': '#ebebeb',
          height: '160px',
          'border-radius': '16px',
          'margin-bottom': '16px'
        }">
      </ngx-skeleton-loader>
    </div>
  </div>
  <div *ngIf="loadingTransacoes <= 0">
    <!-- FILTRO DATATABLE INI -->
    <div class="filtroDinamico" class="col-md-12">
      <app-filtro inputStatusTransacao="Recusadas" [showFilterVehicle]="false" [showFilterDriver]="false"
        [inputShowStatusTransacao]="true" [showDownloadRelatory]="false" (onFiltroInit)="filtroIniciado($event)"
        (onFiltroSelected)="chamadaFiltro($event)" [parent]="this"></app-filtro>
    </div>

    <div class="lista-container">


      <ng-container *ngIf="dataSource.length > 0; else noData">
        <h3><strong>Transações bloqueadas</strong></h3>
        <div class="mt-4">
          <app-extended-mat-table *ngIf="loadingTransacoes <= 0" [columns]="columns" [dataSource]="dataSource"
            [parent]="this" [validaCorLinha]="columnRowData" [showPaginator]="false"
            class="registro-operacoes"></app-extended-mat-table>



        </div>
      </ng-container>

      <ng-template #noData>
        <div class="w-100 d-flex justify-content-center">
          <h3><strong>Não há transações no período!</strong></h3>
        </div>
      </ng-template>

    </div>
    <!-- DATATABLE END -->
  </div>







</div>